/* Collection page: filter drawer, sort, grid density, load more, sticky bar offset. */
(() => {
  const root = document.querySelector('[data-tc-coll]');
  if (!root) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Sticky bar sits under the fixed header while the header is showing
  const bar = root.querySelector('[data-tc-coll-bar]');
  const header = document.querySelector('tc-header');
  const syncTop = () => {
    const hidden = !header || header.classList.contains('is-hidden');
    const h = header ? header.querySelector('.tc-bar').getBoundingClientRect().bottom : 0;
    bar.style.setProperty('--tc-sticky-top', hidden ? '0px' : `${Math.max(h, 0)}px`);
  };
  if (bar) { window.addEventListener('scroll', () => requestAnimationFrame(syncTop), { passive: true }); syncTop(); }

  // Sort
  const sort = root.querySelector('[data-tc-sort]');
  sort && sort.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page');
    location.assign(u.toString());
  });

  // Grid density (desktop)
  const grid = root.querySelector('[data-tc-grid]');
  const colBtns = [...root.querySelectorAll('[data-tc-cols]')];
  const setCols = (n) => {
    root.style.setProperty('--cols', n);
    colBtns.forEach((b) => b.classList.toggle('is-on', b.dataset.tcCols === String(n)));
    try { localStorage.setItem('tc-cols', n); } catch (e) {}
  };
  colBtns.forEach((b) => b.addEventListener('click', () => setCols(b.dataset.tcCols)));
  try { const saved = localStorage.getItem('tc-cols'); if (saved && matchMedia('(min-width: 990px)').matches) setCols(saved); } catch (e) {}

  // Filter drawer
  const drawer = root.querySelector('[data-tc-fdrawer]');
  const openBtn = root.querySelector('[data-tc-filter-open]');
  // Tc.modal keeps focus inside the drawer, makes the page behind it inert and returns focus to Filter on close.
  let release = null;
  const open = () => {
    if (release) return;
    drawer.classList.add('is-open'); openBtn && openBtn.setAttribute('aria-expanded', 'true');
    release = Tc.modal(drawer, openBtn, drawer.querySelector('.tc-fdrawer__close'));
  };
  const close = () => {
    if (!release) return;
    drawer.classList.remove('is-open'); openBtn && openBtn.setAttribute('aria-expanded', 'false');
    release(); release = null;
  };
  if (drawer && openBtn) {
    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-tc-filter-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    // Empty price fields should not be sent
    drawer.querySelector('[data-tc-filter-form]').addEventListener('submit', (e) => {
      e.target.querySelectorAll('input[type="number"]').forEach((i) => { if (i.value === '') i.disabled = true; });
    });
  }

  // Load more: fetch the next page and append its cards
  const more = root.querySelector('[data-tc-more]');
  if (more && grid) {
    more.addEventListener('click', async (e) => {
      e.preventDefault();
      more.classList.add('is-loading'); more.textContent = 'Loading';
      try {
        const html = await (await fetch(more.href)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('[data-tc-grid]');
        const cards = nextGrid ? [...nextGrid.children] : [];
        cards.forEach((c, i) => {
          c.style.setProperty('--tc-i', i % 6);
          if (reduce) c.removeAttribute('data-tc-reveal');
          grid.appendChild(c);
          requestAnimationFrame(() => requestAnimationFrame(() => c.classList.add('is-in')));
        });
        const nextMore = doc.querySelector('[data-tc-more]');
        const shown = doc.querySelector('[data-tc-shown]');
        if (shown) root.querySelector('[data-tc-shown]').textContent = shown.textContent;
        if (nextMore) { more.href = nextMore.href; more.textContent = 'Load more'; more.classList.remove('is-loading'); }
        else { more.closest('.tc-coll__more').remove(); }
      } catch (err) { location.assign(more.href); }
    });
  }
})();
